import Image from 'next/image';

export const VODojoLogo = ({ size }: { size: number }) => {
  return <Image src={`/ex_dojo_logo_512_richblack.png`} alt="VODojo Logo" width={size} height={size} />;
};
